import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { URLSearchParams, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { AgencyLookupSummary } from '../../models/agency-lookup-summary';
import { AgencyLookupDetail } from '../../models/agency-lookup-detail';
import { ResponseUtil } from '../../utils/response-util';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';


@Injectable()
export class AgencyLookupHttpService {

  private agencySearchURL = `${this.environment.baseUrl}/api/lookup/agencies`;
  private agencyDetailsURL = `${this.environment.baseUrl}/api/lookup/agencies/details`;

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  search(searchText: string): Observable<List<AgencyLookupSummary>> {
    let params = new URLSearchParams();
    params.set('query', searchText);

    return this.http.get(this.agencySearchURL, { search: params })
      .map((res: Response) => res.json())
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getDetail(summaryRecord: AgencyLookupSummary): Observable<AgencyLookupDetail> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.post(`${this.agencyDetailsURL}`, JSON.stringify(summaryRecord), options)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.http.service.ts